import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Overview from './Overview'
import Trend from './Trend'
import Source from './Source'
import Store from './store'
import { observer, Provider } from 'mobx-react'

@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()

    this.store.getOverview()
    this.store.getTrend()
    this.store.getSource()
  }
  render() {
    return (
      <Provider store={this.store}>
        <HeaderView title="店铺数据">
          <Overview />
          <Trend />
          <Source />
        </HeaderView>
      </Provider>
    )
  }
}
